// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 438 ? "Login" : chunkId) + "." + {"438":"d1b553ab","787":"adeb6b69"}[chunkId] + ".chunk.js";
};